import { useRef } from "react";
import { Outlet } from "react-router-dom";
import Style from "./Auth.module.scss";
import { Image } from "@wac-ui-dashboard/wac_component_library";
import Assets from "../../assets/Assets";

const AuthModule = () => {
  const emailRef = useRef("");
  const countryCodeRef = useRef("");
  const otpExpiryRef = useRef("");

  return (
    <div className={Style.root}>
      <div className={Style.root_inner}>
        <div className={`${Style.logoWrapper} pro-pb-5`}>
          <Image
            src={Assets.LOGO}
            width={178.9}
            height={34.44}
            alt={`Radio Mango Logo`}
          />
        </div>
        <div className={`${Style.auth} pro-pt-3`}>
          <Outlet context={{ emailRef,countryCodeRef, otpExpiryRef }} />
        </div>
      </div>
    </div>
  );
};

export default AuthModule;
